<template>
  <div class="main-content table-wrapper" style="background: transparent">
    <div style="margin-bottom: 10px">{{ placeholder }}</div>
    <div class="mb-3">
      <span v-if="limit > 0" style="margin-bottom: 10px">({{ 'Limit' | i18n }}: {{ limit }}) :</span>
      <span
        @click="viewMode ? () => {} : deleteItem(r)"
        v-for="r in selectedRow"
        :key="r.id"
        class="selected"
        v-b-tooltip.hover
        :title="'delete' | i18n"
        >{{ r.identifier }}</span
      >
    </div>
    <div class="filter-block">
      <SearchInput :searchChange="searchChange" />
    </div>
    <Table
      :update="getPage"
      :columns="columns"
      :rows="rows"
      :filter="filter"
      :updateFilter="updateFilter"
      :loadingInstance="loadingInstance"
      :setLoadingInstance="setLoadingInstance"
      :onRowClick="viewMode ? () => {} : onRowClick"
      tableName="backendSelectTable"
    />
  </div>
</template>
<script>
import Table from '../table';
import SearchInput from '../search-input';
import { NotificationMixin } from '../../../../mixins';
let inputInterval = null;

export default {
  name: 'BackendSelect',
  components: { Table, SearchInput },
  mixins: [NotificationMixin],
  props: {
    viewMode: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Function,
      default: () => {},
    },
    limit: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      text: null,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      },
      loadingInstance: null,
      columns: [
        {
          field: 'identifier',
          title: this.$translate('Identifier'),
          key: '1',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'title',
          title: this.$translate('Title'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'subtitle',
          title: this.$translate('Subtitle'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'content',
          title: this.$translate('Content'),
          key: '4',
          sortBy: '',
          align: 'left',
        },
      ],
      rows: [],
      selectedRow: [],
    };
  },
  watch: {
    value(newVal) {
      this.selectedRow = newVal || [];
    },
  },
  mounted() {
    this.selectedRow = this.value || [];
  },
  methods: {
    onRowClick(row) {
      const exist = this.selectedRow.find((r) => r.id === row.id);
      if (exist) {
        return;
      }
      if (this.limit) {
        const lng = this.selectedRow.length;
        if (lng >= this.limit) {
          return;
        }
      }
      this.selectedRow.push(row);
      this.$emit('input', this.selectedRow);
    },
    deleteItem(row) {
      this.selectedRow = this.selectedRow.filter((r) => r.id !== row.id);
      this.$emit('input', this.selectedRow);
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, status, dateRange, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (status) {
          ctx.status = status;
        }
        if (dateRange && dateRange.startDate && dateRange.endDate) {
          ctx.startDate = dateRange.startDate;
          ctx.endDate = dateRange.endDate;
        }
        const response = await this.request(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep tr {
  cursor: pointer;
}

.selected {
  background: #2260ff;
  padding: 5px;
  color: white;
  border-radius: 10px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
